import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { mapClickOwnersAtom } from './atoms';

/**
 * Claims map clicks for a tool while `active`, the way measure mode does: the map
 * stands its popups down, and other tools can read `mapClickOwnersAtom` to keep out
 * of the way.
 *
 * Several maps can hold the same id at once, so each caller adds and removes its own
 * entry rather than the id as a whole.
 *
 * @param {string} id - Names the tool, so others can tell whose claim it is.
 * @param {boolean} active - Whether the tool is taking clicks now.
 */
export const useMapClickOwner = (id: string, active: boolean): void => {
  const setOwners = useSetAtom(mapClickOwnersAtom);

  useEffect(() => {
    if (!active) return undefined;
    setOwners((owners) => [...owners, id]);
    return () =>
      setOwners((owners) => {
        const index = owners.indexOf(id);
        return index === -1
          ? owners
          : [...owners.slice(0, index), ...owners.slice(index + 1)];
      });
  }, [id, active, setOwners]);
};
